import React from 'react'

import { FilterHandler } from '@btime/react-contexts'
import TransfersHistoryLoader from './_load/TransfersHistoryLoader'
import TransfersHistoryTable from './table/TransfersHistoryTable'
import Scroll from '../../../../components/helpers/Scroll'

const TransfersHistory = () => {
  return (
    <Scroll overflowX={'hidden'} overflowY={'auto'} maxHeight="35rem" width="45rem" height="100%">
      <FilterHandler>
        <TransfersHistoryLoader>
          <TransfersHistoryTable />
        </TransfersHistoryLoader>
      </FilterHandler>
    </Scroll>
  )
}

export default TransfersHistory
